function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

import { sanitize } from '../../tools/serialisation/sanitize';
import { jsonStringify } from '../../tools/serialisation/jsonStringify';
import { computeStackTrace } from '../../tools/stackTrace/computeStackTrace';
import { toStackTraceString } from '../../tools/stackTrace/handlingStack';
export var NO_ERROR_STACK_PRESENT_MESSAGE = 'No stack, consider using an instance of Error';
export function computeRawError(_ref) {
  var stackTrace = _ref.stackTrace,
      originalError = _ref.originalError,
      handlingStack = _ref.handlingStack,
      componentStack = _ref.componentStack,
      startClocks = _ref.startClocks,
      nonErrorPrefix = _ref.nonErrorPrefix,
      _ref$useFallbackStack = _ref.useFallbackStack,
      useFallbackStack = _ref$useFallbackStack === void 0 ? true : _ref$useFallbackStack,
      source = _ref.source,
      handling = _ref.handling;
  var isErrorInstance = isError(originalError);

  if (!stackTrace && isErrorInstance) {
    stackTrace = computeStackTrace(originalError);
  }

  return {
    startClocks: startClocks,
    source: source,
    handling: handling,
    handlingStack: handlingStack,
    componentStack: componentStack,
    originalError: originalError,
    type: stackTrace ? stackTrace.name : undefined,
    message: computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError),
    stack: stackTrace ? toStackTraceString(stackTrace) : useFallbackStack ? NO_ERROR_STACK_PRESENT_MESSAGE : undefined,
    causes: isErrorInstance ? flattenErrorCauses(originalError, source) : undefined,
    fingerprint: tryToGetFingerprint(originalError),
    context: tryToGetErrorContext(originalError)
  };
}

function computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError) {
  // Favor stackTrace message only if tracekit has really been able to extract something meaningful (message + name)
  // TODO rework tracekit integration to avoid scattering error building logic
  return (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.message) && (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name) ? stackTrace.message : !isErrorInstance ? "".concat(nonErrorPrefix, " ").concat(jsonStringify(sanitize(originalError))) : 'Empty message';
}

export function tryToGetFingerprint(originalError) {
  return isError(originalError) && 'dd_fingerprint' in originalError ? String(originalError.dd_fingerprint) : undefined;
}
export function tryToGetErrorContext(originalError) {
  if (originalError !== null && _typeof(originalError) === 'object' && 'dd_context' in originalError) {
    return originalError.dd_context;
  }
}
export function getFileFromStackTraceString(stack) {
  var _a;

  return (_a = /@ (.+)/.exec(stack)) === null || _a === void 0 ? void 0 : _a[1];
}
export function isError(error) {
  return error instanceof Error || Object.prototype.toString.call(error) === '[object Error]';
}
export function flattenErrorCauses(error, parentSource) {
  var currentError = error;
  var causes = [];

  while (isError(currentError === null || currentError === void 0 ? void 0 : currentError.cause) && causes.length < 10) {
    var stackTrace = computeStackTrace(currentError.cause);
    causes.push({
      message: currentError.cause.message,
      source: parentSource,
      type: stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name,
      stack: stackTrace && toStackTraceString(stackTrace)
    });
    currentError = currentError.cause;
  }

  return causes.length ? causes : undefined;
}